import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-sound-low-fill')
export class ObiSoundLowFill extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.41797V9.76448C16.3344 10.0636 16.5995 10.437 16.7716 10.8525C16.9224 11.2165 17 11.6066 17 12.0005C17 12.3945 16.9224 12.7846 16.7716 13.1486C16.5995 13.5641 16.3344 13.9375 16 14.2366V16.5831C16.5725 16.3332 17.0934 15.9782 17.5355 15.5361C17.9998 15.0718 18.3681 14.5206 18.6194 13.914C18.8707 13.3073 19 12.6572 19 12.0005C19 11.3439 18.8707 10.6938 18.6194 10.0871C18.3681 9.4805 17.9998 8.9293 17.5355 8.46501C17.0934 8.0229 16.5725 7.66784 16 7.41797Z" fill="currentColor"/>
<path d="M5.2 15.9999C4.07989 15.9999 3.51984 15.9999 3.09202 15.7819C2.71569 15.5901 2.40973 15.2842 2.21799 14.9078C2 14.48 2 13.92 2 12.7999V11.1999C2 10.0797 2 9.5197 2.21799 9.09187C2.40973 8.71555 2.71569 8.40959 3.09202 8.21784C3.51984 7.99985 4.0799 7.99985 5.2 7.99985H8L11.2686 4.73123C12.1254 3.87447 12.5538 3.4461 12.9215 3.41715C13.2407 3.39204 13.5525 3.52121 13.7604 3.76462C14 4.04515 14 4.65096 14 5.8626V18.1371C14 19.3487 14 19.9546 13.7604 20.2351C13.5525 20.4785 13.2407 20.6077 12.9215 20.5826C12.5538 20.5536 12.1254 20.1252 11.2686 19.2685L8 15.9999H5.2Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M16 7.41797V9.76448C16.3344 10.0636 16.5995 10.437 16.7716 10.8525C16.9224 11.2165 17 11.6066 17 12.0005C17 12.3945 16.9224 12.7846 16.7716 13.1486C16.5995 13.5641 16.3344 13.9375 16 14.2366V16.5831C16.5725 16.3332 17.0934 15.9782 17.5355 15.5361C17.9998 15.0718 18.3681 14.5206 18.6194 13.914C18.8707 13.3073 19 12.6572 19 12.0005C19 11.3439 18.8707 10.6938 18.6194 10.0871C18.3681 9.4805 17.9998 8.9293 17.5355 8.46501C17.0934 8.0229 16.5725 7.66784 16 7.41797Z" style="fill: var(--element-active-color)"/>
<path d="M5.2 15.9999C4.07989 15.9999 3.51984 15.9999 3.09202 15.7819C2.71569 15.5901 2.40973 15.2842 2.21799 14.9078C2 14.48 2 13.92 2 12.7999V11.1999C2 10.0797 2 9.5197 2.21799 9.09187C2.40973 8.71555 2.71569 8.40959 3.09202 8.21784C3.51984 7.99985 4.0799 7.99985 5.2 7.99985H8L11.2686 4.73123C12.1254 3.87447 12.5538 3.4461 12.9215 3.41715C13.2407 3.39204 13.5525 3.52121 13.7604 3.76462C14 4.04515 14 4.65096 14 5.8626V18.1371C14 19.3487 14 19.9546 13.7604 20.2351C13.5525 20.4785 13.2407 20.6077 12.9215 20.5826C12.5538 20.5536 12.1254 20.1252 11.2686 19.2685L8 15.9999H5.2Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-sound-low-fill': ObiSoundLowFill;
  }
}
